import {
  MOBILE_VIEWPORT_MEDIA_QUERY,
  shouldBlockMobileViewport,
} from '@/common/utils/mobileDesktopOnly'
import { computed, onMounted, onUnmounted, ref } from 'vue'

export function useMobileDesktopOnlyBlocker() {
  const blocked = ref(shouldBlockMobileViewport())

  onMounted(() => {
    const mediaQuery = window.matchMedia(MOBILE_VIEWPORT_MEDIA_QUERY)

    const syncBlocked = () => {
      blocked.value = shouldBlockMobileViewport()
    }

    syncBlocked()
    mediaQuery.addEventListener('change', syncBlocked)

    onUnmounted(() => {
      mediaQuery.removeEventListener('change', syncBlocked)
    })
  })

  return {
    isBlocked: computed(() => blocked.value),
  }
}
